import { createSlice } from '@reduxjs/toolkit';

export const initialDataState = {
  apiUrl: '',
  openHttpRequests: 0,
  isLoading: true,
  fullShape: null,
  filteredShape: null,
};

const dataSlice = createSlice({
  name: 'data',
  initialState: initialDataState,
  reducers: {
    setApiUrl(state, action) {
      state.apiUrl = action.payload;
    },
    setFullShape(state, action) {
      state.fullShape = action.payload;
    },
    setFilteredShape(state, action) {
      state.filteredShape = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    addHttpRequestCount(state) {
      state.openHttpRequests += 1;
      if (state.openHttpRequests > 0) {
        state.isLoading = true;
      }
    },
    subtractHttpRequestCount(state) {
      state.openHttpRequests -= 1;
      if (state.openHttpRequests === 0) {
        state.isLoading = false;
      }
    },
  },
});

export const dataActions = dataSlice.actions;

export default dataSlice.reducer;
